import { defineStore } from "pinia";
import { useGeneralStore } from "%/stores/general-store";

const waitersByMedia = new Map();

export const useMediaPlaybackStore = defineStore("media-playback-store", {
  state: () => ({
    playbackByMedia: {},
    unresolvableMediaIds: {},
  }),
  getters: {
    isMediaUnresolvable(state) {
      return mediaId => !!state.unresolvableMediaIds[mediaId];
    },
    orgId() {
      return useGeneralStore().orgId;
    },
  },
  actions: {
    seedResolvedMedia(playbackByMediaId) {
      Object.entries(playbackByMediaId ?? {}).forEach(([mediaId, playback]) => {
        if (!playback?.url || this.playbackByMedia[mediaId]) {
          return;
        }
        this.playbackByMedia[mediaId] = playback;
      });
    },
    seedUnresolvableMedia(mediaIds) {
      (mediaIds ?? []).forEach(mediaId => {
        this.unresolvableMediaIds[mediaId] = true;
      });
    },
    resolveMediaPlayback(mediaId, successCallback = () => {}, errorCallback = () => {}) {
      if (!mediaId || this.unresolvableMediaIds[mediaId]) {
        errorCallback();
        return;
      }
      const resolved = this.playbackByMedia[mediaId];
      if (resolved) {
        successCallback(resolved);
        return;
      }
      const waiting = waitersByMedia.get(mediaId);
      if (waiting) {
        waiting.push({ successCallback, errorCallback });
        return;
      }
      waitersByMedia.set(mediaId, [{ successCallback, errorCallback }]);
      this.apiGet(`/media/${mediaId}`, {}, data => {
        if (data?.url) {
          this.playbackByMedia[mediaId] = data;
        }
        this.settleMediaPlayback(mediaId, waiter => waiter.successCallback(data));
      }, error => {
        this.settleMediaPlayback(mediaId, waiter => waiter.errorCallback(error));
      });
    },
    forgetMediaPlayback(mediaId) {
      delete this.playbackByMedia[mediaId];
    },
    updateAudioDetails(mediaId, details, successCallback, errorCallback) {
      this.apiPost(`/media/${mediaId}/details`, { org_id: this.orgId, ...details }, data => {
        this.forgetMediaPlayback(mediaId);
        successCallback(data);
      }, errorCallback);
    },
    settleMediaPlayback(mediaId, invokeWaiter) {
      const waiters = waitersByMedia.get(mediaId) ?? [];
      waitersByMedia.delete(mediaId);
      waiters.forEach(invokeWaiter);
    },
  },
});

export default useMediaPlaybackStore;
